module.exports = __webpack_public_path__ + "img/7.c0f55c1d.jpg";